// Beta Sign-Up Service
// Invite-code sign-up, code requests and account activation (ITER-098)

import { FirebaseError } from 'firebase/app';
import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';

export interface RedeemInviteCodeParams {
  code: string;
  email: string;
  password: string;
  displayName: string;
  termsVersion: string;
}

export interface RequestInviteCodeParams {
  name: string;
  email: string;
  note: string;
}

const PASS_THROUGH_ERROR_CODES = [
  'functions/failed-precondition',
  'functions/already-exists',
  'functions/invalid-argument',
];

export async function redeemInviteCode(params: RedeemInviteCodeParams): Promise<void> {
  const callable = httpsCallable<RedeemInviteCodeParams, { ok: boolean }>(functions, 'redeemInviteCode');
  await callable(params);
}

export async function requestInviteCode(params: RequestInviteCodeParams): Promise<void> {
  const callable = httpsCallable<RequestInviteCodeParams, { ok: boolean }>(functions, 'requestInviteCode');
  await callable(params);
}

export async function activateBetaAccount(): Promise<{ activated: boolean }> {
  const callable = httpsCallable<void, { activated: boolean }>(functions, 'activateBetaAccount');
  const result = await callable();
  return { activated: result.data.activated };
}

export function signUpErrorMessage(error: unknown): string {
  if (error instanceof FirebaseError && PASS_THROUGH_ERROR_CODES.includes(error.code)) {
    return error.message;
  }
  return 'Something went wrong. Please try again.';
}
